import { GET_ALL_PARAMETERS, GET_ALL_PARAMETERS_SUCCESS, GET_ALL_PARAMETERS_ERROR} from './actionTypes';

const initialState = {
    errorGetAllParams: "",
    loadingGetAllParams: false,
    allParams: null,
    successAllParams: ""
}

const getAllParams = (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_PARAMETERS:
            state = {
                ...state,
                loadingGetAllParams: true
            }
            break;
        case GET_ALL_PARAMETERS_SUCCESS:
            state = {
                ...state,
                loadingGetAllParams: false,
                allParams: action.payload.params, 
                successAllParams: action.payload.message
            }
            break;
        case GET_ALL_PARAMETERS_ERROR:
            state = { ...state, errorGetAllParams: action.payload, loadingGetAllParams: false };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default getAllParams;